import React from "react"
import { Button, ButtonProps } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"

export type FaButtonProps = ButtonProps & { icon: IconProp }

export const FaButton: React.FC<FaButtonProps> = (props) => {
    const { icon, ...btnProps } = props

    return (
        <Button {...btnProps}>
            <FontAwesomeIcon
                fixedWidth
                icon={icon}
                className="mr-2"
            />
            {props.children}
        </Button>
    )
}
